$('.hpe-slot').each(function () {
  const slotCount = $(this).attr('data-count');
  const slotMax = $(this).attr('data-max');
  const slotValue = slotMax - slotCount + 1;
  $(this)
    .children(`.hpe-slot__item[data-slot-item="${slotValue}"]`)
    .addClass('hpe-slot__item--active');
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/slot.js